import React, { useContext, useMemo } from "react";
import { useSearchParams } from "../Hooks/useSearchParams";
import { DrawInput } from "../common/Inputs/DrawInput";
import { IdentifierMappingContext } from "./IdentifierMappingContext";

export const IdentifierMappingDraw = () => {
  const {
    coveredEntity340bId,
    setCoveredEntity340bId,
    coveredEntity340bIds,
    setPharmacyGroupSearch,
    setActivePharmacyGroup,
    setPharmacyGroupTab,
  } = useContext(IdentifierMappingContext);

  const coveredEntityOptions = useMemo(
    () => coveredEntity340bIds.map((id) => ({ label: id, value: id })),
    [coveredEntity340bIds]
  );

  const [searchParams, setSearchParams] = useSearchParams();

  const handleCoveredEntityClick = (value) => {
    if (coveredEntity340bId === value) {
      return;
    }

    setSearchParams({
      ...searchParams,
      pharmacy_group: undefined,
      pharmacy_group_search: undefined,
      id_340b: value,
    });
    setPharmacyGroupTab("pharmacies");
    setActivePharmacyGroup(null);
    setPharmacyGroupSearch("");
    setCoveredEntity340bId(value);
  };

  return (
    <div className="draw__container draw__container--scroll">
      <DrawInput
        label="Covered Entity"
        items={coveredEntityOptions}
        selected={coveredEntity340bId}
        setSelected={(val) => handleCoveredEntityClick(val)}
        required={true}
      />
    </div>
  );
};
